module.exports = __webpack_public_path__ + "static/media/h350_14.5fde028162cef9c8ce4eb4816e0d3e67.png";